/** In-memory only — never persisted to browser storage. */

let pendingOpenChatId = null;

export const setPendingOpenChatId = (chatId) => {
  pendingOpenChatId = chatId != null ? String(chatId) : null;
};

export const consumePendingOpenChatId = () => {
  const id = pendingOpenChatId;
  pendingOpenChatId = null;
  return id;
};

export const OPEN_CHAT_EVENT = 'lynx:open-chat';
export const NAVIGATE_TO_CHAT_EVENT = 'lynx:navigate-to-chat';

export const dispatchOpenChat = (chatId) => {
  if (chatId == null) {
    return;
  }
  window.dispatchEvent(
    new CustomEvent(OPEN_CHAT_EVENT, { detail: { chatId: String(chatId) } }),
  );
};

export const dispatchNavigateToChat = (chatId) => {
  window.dispatchEvent(
    new CustomEvent(NAVIGATE_TO_CHAT_EVENT, { detail: { chatId: chatId != null ? String(chatId) : null } }),
  );
};
